"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ArticleSpecSchema = void 0;
const zod_1 = require("zod");
exports.ArticleSpecSchema = zod_1.z.enum(['espoolOnly', 'espoolReady', 'Chainflex', 'Readycable', 'PullWire', 'erkReady', 'SmartPlasticsOnly', 'ECPSensor', 'ECPSensorCable', 'ECPDummy', 'ECW', 'ECWSensor', 'ECWBlackbox', 'ECWSensorCable', 'IsenseModule', 'IceeModule', 'SMSModule', 'SMSModuleCable', 'SimCard', 'Modem']);
exports.default = exports.ArticleSpecSchema;
//# sourceMappingURL=ArticleSpecSchema.js.map